<template>
	<window-view title="Medlemsskab" v-on="$listeners" :width="400" :actions="_actions">
		<panel-view>
			<panel-sep-view>
				<grid-view>
					<select-view v-model="m.organisationId" :options="_organisations" label="Organisation" />
				</grid-view>
				<grid-view>
					<select-view v-model="m.role" :options="_roles" label="Rolle" />
				</grid-view>				
			</panel-sep-view>
		</panel-view>
	</window-view>
</template>

<script>
	import user from '../../../model/user';

	const ORG_ROLES = {
		ORG_ADMIN: {
			label: 'Administrator',
			class: 'ORG_ADMIN',
		},
		ORG_CAREGIVER: {
			label: 'Plejer',
			class: 'ORG_CAREGIVER',
		},
	};

	export default {
		props: ['model', 'submit'],
		data() {
			return {
				id: '',
				m: user.model(),
				organisations: [],
			};
		},
		computed: {
			_roles() {
				return Object.keys(ORG_ROLES).map(key => {
					return {
						label: ORG_ROLES[key].label,
						value: ORG_ROLES[key].class,
					};
				});
			},
			_organisations() {
				return this.organisations.map(val => {
					return {
						label: val.label,
						value: val.id,
					};
				});
			},
			_actions() {
				const self = this;

				return [
					{
						label: 		'Annuller',
						emphasis: 	'text',
						action:		() => true
					},
					{
						label: 		'Gem',
						action: 	async () => {
							return self.submit(this.m);
						}
					}
				];
			}
		},
		async created() {
			console.log('m', this.model);
			this.m = {...this.m, ...this.model};

			this.organisations = (await this.axios.get('/organisations?_size=100')).data.content;
		}
	}
</script>

<style lang="scss" scoped>

</style>